<template>
<section>
  <timeline ref="timeline"
    :items="timeline.items"
    :groups="timeline.groups"
    :options="timeline.options"
    ></timeline>

  <b-tabs pills card vertical nav-wrapper-class="w-10">
    <b-tab title="お知らせ" active>
      <information></information>
    </b-tab>

    <b-tab title="かんたん" @click="redrawTimeline">
      <easy-form
        :telescopeId="telescopeId"
        :telescopeList="telescopeList"
        :dateList="dateList"
        :targetList="targetList"
        @addedBooking="pushTimeline"
        @telescopeChanged="onTelescopeChanged"
      ></easy-form>
    </b-tab>

    <b-tab title="予約" @click="redrawTimeline">
      <booking-form
        :telescopeId="telescopeId"
        :telescopeList="telescopeList"
        :limitAngle="limitAngle"
        :location="location"
        :dateList="dateList"
        :epochDict="epochDict"
        @addedBooking="pushTimeline"
        @telescopeChanged="onTelescopeChanged"
        ></booking-form>
    </b-tab>

    <b-tab title="予約確認">
      <booking-list ref="bookingList" :telescopeId="telescopeId" :telescopeList="telescopeList" :bookings="bookings" @telescopeChanged="onTelescopeChanged"></booking-list>
    </b-tab>

    <b-tab title="画像">
      <gallery></gallery>
    </b-tab>
  </b-tabs>
</section>
</template>

<style>
@import "~vis/dist/vis.css";
</style>

<script>
import axios from 'axios'
import firebase from 'firebase'
import moment from 'moment'
import Information from '../components/Information.vue'
import BookingForm from '../components/BookingForm.vue'
import BookingList from '../components/BookingList.vue'
import EasyForm from '../components/EasyForm.vue'
import Gallery from '../components/Gallery.vue'

function jdn(date) {
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const hour = date.getHours();
    // Earliest year allowed (4800BC)
    const IYMIN = -4799;
    // Month lengths in days
    const mtab = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    // Validate year and month.
    if (year < IYMIN) {
        throw new Error("bad year");
    }
    if (month < 1 || month > 12) {
        throw new Error("bad month");
    }
    // If February in a leap year, 1, otherwise 0.
    const leap = ((month == 2) && (year % 4 == 0) && (year % 100 != 0 || year % 400 == 0));
    // Validate day, taking into account leap years.
    if (day < 1 || day > (mtab[month - 1] + (leap ? 1 : 0))) {
        throw new Error("bad day");
    }
    // Return result.
    const my = (month <= 2 ? -1 : 0);
    const iypmy = year + my;
    const djm = Math.floor((1461 * (iypmy + 4800)) / 4)
        + Math.floor((367 * (month - 2 - 12 * my)) / 12)
        - Math.floor((3 * Math.floor((iypmy + 4900) / 100)) / 4)
        + day - 2432076;
    return parseInt(String(2400000 + djm + (hour < 12 ? -1 : 0)));
}

function current_jdn() {
    return jdn(new Date());
}

// from astropy
function jd2cal(dj) {
    // Minimum and maximum allowed JD
    const DJMIN = -68569.5;
    const DJMAX = 1e9;

    // Verify date is acceptable.
    if (dj < DJMIN || dj > DJMAX) {
        return null;
    }

    // Copy the date, big then small, and re-align to midnight.
    let jd1 = dj;
    let jd2 = -0.5;

    // Separate day and fraction.
    const f1 = jd1 % 1.0;
    const f2 = jd2 % 1.0;
    let f = (f1 + f2) % 1.0;
    if (f < 0.0) {
        f += 1.0;
    }
    function ERFA_DNINT(a) {
        return (a < 0.0) ? (Math.ceil(a - 0.5)) : (Math.floor(a + 0.5));
    }
    function int(n) {
        return parseInt(n);
    }
    let d = ERFA_DNINT(jd1 - f1) + ERFA_DNINT(jd2 - f2) + ERFA_DNINT(f1 + f2 -f);
    let jd = int(ERFA_DNINT(d) + 1)

    // Express day in Gregorian calendar.
    let l = jd + 68569;
    let n = int((4 * l) / 146097);
    l -= int((146097 * n + 3) / 4);
    let i = int((4000 * (l + 1)) / 1461001);
    l -= int((1461 * i) / 4) - 31;
    let k = int((80 * l) / 2447);
    let day = l - int((2447 * k) / 80);
    l = int(k / 11);
    let month = k + 2 - 12 * l;
    let year = 100 * (n - 49) + i + l;
    return {
        year: year,
        month: month,
        day: day,
        f: f,
        date: new Date(new Date(Date.UTC(year, month-1, day)).getTime() + (24 * 60 * 60 * f) * 1000),
    };
}

export default {
  name: 'home',
  data() {
    let today = moment()
    let genNum = (num) => {
      let list = []
      for (let i = 0; i < num; i++) { list.push(i + 1) }
      return list
    }
    return {
      API_ROOT: this.$store.state.config.API_ROOT,
      session: this.$store.state.loginUser.session,

      telescopeId: "63ce0ad6-8eb4-4007-9c57-4e1c6eb2d8cd",
      telescopeList: [{
        text: "南阿蘇ルナ天文台 82cm D810A",
        value: "63ce0ad6-8eb4-4007-9c57-4e1c6eb2d8cd"
      }],

      status: {},
      limitAngle: 30.0,
      location: {},
      dateList: [],
      epochDict: {},
      targetList: [],

      bookings: [],

      imageList: [
        require('../assets/M1.png'),
        require('../assets/M27.png'),
        require('../assets/M33.png'),
        require('../assets/M34.png'),
        require('../assets/M51.png'),
        require('../assets/M52.png'),
        require('../assets/M101.png'),
        require('../assets/M104.png'),
      ]
    }
  },
  mounted() {
  },
  created() {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        if (this.session.user) {
          this.session.user.getIdToken(true).then((idToken) => {
            this.reloadStatusInfo(idToken);
            this.reloadBooking(idToken);
            this.reloadRecommendObject(idToken);
          });
        }
      }
    });
  },
  computed: {
    timeline() {
      let tl = {
        id: 0,
        items:[],
        groups:[{id:0}],
        options: {
          editable: false,
          moveable: true,
          selectable: false,
          showMajorLabels: true,
          showMinorLabels: true,
          hiddenDates: [{
            start: moment().subtract(1,'d').hours(5).minutes(0).second(0),
            end: moment().subtract(1,'d').hours(19).minutes(0).second(0),
            repeat: 'daily'
          }],
          margin: {item: {horizontal:0, vertical: 10}},
          start: moment().hours(19).minutes(0).second(0),
          end: moment().add(1,'d').hours(5).minutes(0).second(0),
        }
      }

      let itemId = 0
      for (let booking of this.bookings) {
        const start = moment(booking.Time.Start)
        const end = moment(booking.Time.Limit)
        tl.items.push({
          id: booking.ID,
          group: 0,
          start: start,
          end: end,
          content: booking.TargetName
        })
      }
      return tl
    },
  },
  methods: {
    pushTimeline(booking) {
      this.bookings.push(booking)
      this.refreshOrder()
    },
    redrawTimeline() {
      this.$refs.timeline.redraw()
    },
    reloadStatusInfo(idToken) {
      axios.get(this.$store.state.config.API_ROOT + "/service/status", {
        headers: {
          "Authorization": "Bearer " + idToken,
        }
      }).then((response) => {
        this.status = {};
        // telescopeList
        const telescopeList = [];
        for (let uid in response.data.telescopes) {
          const telescope = response.data.telescopes[uid];
          telescopeList.push({
            text: telescope.DisplayName,
            value: telescope.ID,
          });
          this.status[uid] = {};
          this.status[uid].limitAngle = telescope.Limit.Angle;
          this.status[uid].location = telescope.Location;
        }
        this.telescopeList = telescopeList;
        // status
        for (let uid in response.data.statuses) {
          const status = response.data.statuses[uid];
          const datelist = [];
          const epochDict = {};
          for (let i in status.Allow) {
            const a = status.Allow[i];
            const begin = parseInt(a.Begin);
            const end = parseInt(a.End);
            const cal = moment(jd2cal(begin).date);
            epochDict[cal.format("YYYY-MM-DD")] = a.Epoch;
            for (let jd=begin; jd <= end; ++jd) {
              if ( ! datelist.includes(jd) ) {
                datelist.push(jd);
              }
            }
          }
          datelist.sort();
          for (let i in datelist) {
            const time = moment(jd2cal(datelist[i]).date);
            datelist[i] = {
              text: time.format("YYYY年MM月DD日"),
              value: time.format("YYYY-MM-DD"),
            };
          }
          this.status[uid].dateList = datelist;
          this.status[uid].epochDict = epochDict;
        }
      });
    },
    reloadBooking(idToken, uid=null) {
      axios.get(this.$store.state.config.API_ROOT + "/schedule/list/" + (uid || this.telescopeId), {
        headers: {
          "Authorization": "Bearer " + idToken
        }
      }).then((response) => {
        this.bookings = response.data;
        this.refreshOrder();
      });
    },
    reloadRecommendObject(idToken, uid=null) {
      axios.get(this.$store.state.config.API_ROOT + "/objects/list/" + (uid || this.telescopeId), {
        headers: {
          "Authorization": "Bearer " + idToken
        }
      }).then((response) => {
        const targetList = [];
        for ( let i in response.data ) {
          targetList.push({
            text: response.data[i].data.DisplayName,
            value: response.data[i].data.DisplayName
          });
        }
        function split_name(name) {
            const m = name.match(/([A-Z]+)(\d+)/);
            if ( ! m ) {
                return [name, null];
            }
            return [m[1], parseInt(m[2])];
        }
        targetList.sort((a, b) => {
            const aobj = split_name(a.text);
            const bobj = split_name(b.text);
            if ( aobj[0] != bobj[0] ) {
                // another catalog
                if ( aobj[0] < bobj[0] ) {
                    return -1;
                }
                if ( aobj[0] > bobj[0] ) {
                    return 1;
                }
                return 0;
            } else {
                // same catalog
                if ( aobj[1] < bobj[1] ) {
                    return -1;
                }
                if ( aobj[1] > bobj[1] ) {
                    return 1;
                }
                return 0;
            }
        });
        this.targetList = targetList;
      });
    },
    refreshOrder() {
      this.bookings.sort((a, b) => {
        if (a.Time.Start < b.Time.Start) {
          return -1;
        } else if (a.Time.Start > b.Time.Start) {
          return 1;
        }
        return 0;
      });
    },
    onTelescopeChanged(uid) {
      // update booking form
      this.telescopeId = uid;
      this.dateList = this.status[uid].dateList;
      this.epochDict = this.status[uid].epochDict;
      this.limitAngle = this.status[uid].limitAngle;
      this.location = this.status[uid].location;
      // update booking list
      if (this.session.user) {
        this.session.user.getIdToken(true).then((idToken) => {
          this.reloadBooking(idToken, uid);
          this.reloadRecommendObject(idToken, uid);
        });
      }
    }
  },
  components: {
    Information, BookingForm, BookingList, EasyForm, Gallery
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Home.vue